<div class="row">
  <app-form-field label="Adresse e-mail" [required]="true" size="12" [sizeLg]="12" [sizeXl]="12">
    <app-email-input [parentFormGroup]="formGroup" parentFormControlName="to"></app-email-input>
  </app-form-field>
    <app-form-field label="Expéditeur">
        <app-communication-configuration-email-sender-select
                (elementsLoadedEvent)="configurationsLoaded($event)"
                [parentFormGroup]="formGroup" parentFormControlName="senderConfigId"></app-communication-configuration-email-sender-select>
    </app-form-field>
  <app-form-field label="Sujet" [required]="true">
    <app-input-text [parentFormGroup]="formGroup" parentFormControlName="subject"></app-input-text>
  </app-form-field>
  <app-form-field size="12" label="Documents à inclure" *ngIf="canAddDocuments && partnerId">
    <app-loading *ngIf="(documentPaginatedService.loading$ | async) || (stickyPaginatedService.loading$ | async)" [showText]="false"></app-loading>
    <app-error-text *ngIf="(documentPaginatedService.error$ | async) || (stickyPaginatedService.error$ | async)" message="Chargement des documents impossible"></app-error-text>
    <app-document-multiple-select-filter [parentFormGroup]="formGroup" parentFormControlName="documentIds" *ngIf="documents" [documents]="documents"></app-document-multiple-select-filter>
  </app-form-field>
  <div class="col-12">
    <app-communication-content-editor
            [formatContentService]="formatContentService"
            [substitutionAdditionalCategoryValues]="substitutionAdditionalCategoryValues"
            [buildFormatContentPayload]="buildFormatContentPayload"
            [parentFormGroup]="formGroup" parentFormControlName="content"
            [initialContent]="initialContent"
            [partnerId]="partnerId"></app-communication-content-editor>
  </div>
</div>

